import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent, getCurrentInstance, computed, watch } from 'vue';

// Components
import {
  CavuButton,
  ProgressionStepper,
  BackButton,
} from 'ui-shared-components';

interface Props {
  travelInsuranceValidation?: Validation;
  loungePassValidation?: Validation;
  isCompleteTravellerDetailsDisabled?: boolean;
  isLoading?: boolean;
  closeModalOnCompleteTravellerDetail?: boolean;
}

type Validation = {
  $dirty: boolean;
  $invalid: boolean;
  $touch: () => void;
  $each?: {
    [key: number]: {
      $touch: () => void;
      $error: boolean;
    }
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'additional-travellers-combined-products-modal',
  props: {
    travelInsuranceValidation: { default: () => ({
    $dirty: false,
    $invalid: false,
    $touch: () => {},
    $each: {},
  }) },
    loungePassValidation: { default: () => ({
    $dirty: false,
    $invalid: false,
    $touch: () => {},
    $each: {},
  }) },
    isCompleteTravellerDetailsDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    closeModalOnCompleteTravellerDetail: { type: Boolean, default: true }
  },
  emits: ["close", "update-traveller-details"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'update-traveller-details'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { travelInsuranceValidation: Validation, loungePassValidation: Validation, isCompleteTravellerDetailsDisabled: boolean, isLoading: boolean, closeModalOnCompleteTravellerDetail: boolean };

//core
const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;






const activeStepProxy = ref<number>(0);


watch(
  activeStepProxy,
  (targetStep: number | undefined, prevStep: number | undefined) => {
    if (targetStep === undefined) {
      // Step was removed - close the modal
      closeModal();
    } else if (prevStep !== undefined && targetStep < prevStep) {
      // Step decreased - go back to previous step
      activeStepProxy.value = targetStep;
    } else if (prevStep !== undefined && targetStep > prevStep) {
      // Step increased - only allow going forward if previous step is valid
      if (stepIsValid(prevStep)) {
        activeStepProxy.value = targetStep;
      }
    }
  },
)


const closeModal = (): void => {
  if (!props.isLoading) {
    emit('close');
  }
};

const IconClose = defineAsyncComponent(() => import('@white-label-icon/icon-close'));

const stepperSteps = ref([
  { label: proxy?.$t('additionalTravellersCombinedProducts.stepper.travelInsurance') || 'Travel Insurance' },
  { label: proxy?.$t('additionalTravellersCombinedProducts.stepper.lounge') || 'Lounge' },
  { label: proxy?.$t('additionalTravellersCombinedProducts.stepper.summary') || 'Summary' },
]);

const stepIsValid = (step: number): boolean => {
  if (step === 0) {
    return !props.travelInsuranceValidation?.$invalid;
  } else if (step === 1) {
    return !props.loungePassValidation?.$invalid;
  } else {
    return true;
  }
};

const currentStepIsValid = computed(() => {
  return stepIsValid(activeStepProxy.value);
});


function handleNextLounge() {
  props.travelInsuranceValidation.$touch();
  if (!currentStepIsValid.value) {
    return;
  }
  activeStepProxy.value = 1;
};
function handleNextSummary() {
  props.loungePassValidation.$touch();
  if (!currentStepIsValid.value) {
    return;
  }
  activeStepProxy.value = 2;
};

function handleNextCompleteTravellerDetails() {
  emit('update-traveller-details');
  if (props.closeModalOnCompleteTravellerDetail) {
    closeModal();
  }
};


return { __sfc: true,instance, proxy, props, emit, activeStepProxy, closeModal, IconClose, stepperSteps, stepIsValid, currentStepIsValid, handleNextLounge, handleNextSummary, handleNextCompleteTravellerDetails, CavuButton, ProgressionStepper, BackButton }
}

})